//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk'; 

export default {
  name: 'backStore',
  components: {
      cmBlank,cmLoadmore
  },
  data () {
    return {
        blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      backPop:false,
      popBg:false,
      code:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      isActive:0,
      type:0,
      itemId:0,
      list:[],
      types:[
          {
              key:0,
              text:'昨日出厂'
          },
          {
              key:1,
              text:'已出厂未到店'
          },
          {
              key:2,
              text:'已回店'
          },
      ],
    }
  },
  created(){
    this.config();
  
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    selectType(key){
        this.loadStatus = false;
        this.isActive = key;
        this.lastId = 0;
        this.list = [];
        this.loadmore();
    },
    getList(){
        switch(parseInt(this.isActive)){
            case 1:
                this.$api.outFactoryList({last_id:this.lastId,page_flag:this.pageFlag}).then((res)=>{
                    if(res){
                        console.log(res);
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            this.list.push(item);
                        });
                    }
                }) 
                break;
            case 2:
                this.$api.historyBackStore({last_id:this.lastId,page_flag:this.pageFlag}).then((res)=>{
                    if(res){
                        console.log(res);
                        // if(!this.lastId){
                        //     this.blankShow = res.data.length > 0 ? false : true;
                        // }
                        // this.hasNext = res.hasNext;
                        // this.lastId = res.lastId;
                        // res.data.forEach((item)=>{
                        //     this.list.push(item);
                        // });
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            this.list.push(item);
                        });
                        console.log(this.lastId,this.hasNext);
                    }
                }) 
                break;
            default:
                this.$api.yesterdayOutFactory({last_id:this.lastId,page_flag:this.pageFlag}).then((res)=>{
                    if(res){
                        console.log(res);
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            this.list.push(item);
                        });
                    }
                }) 
            break;
        } 
    },
    barCode(code){
        this.$router.push({name:'barOrder',params:{code:code}})
    },
    scanQRCode(e){
        let that = this;
        this.type = e;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr.split(',')[1];
                    that.backStore();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    closePop(){
        this.selectType(0);
        this.popBg = false;
        this.backPop = false;
        this.type = 0;
    },
    openPop(){
        this.popBg = true;
        this.backPop = true;
    },
    backStore(){
      //  this.$func.showToast(this.code);
      // return;
      let that = this;
      if(!this.code){
        that.$func.showToast('衣物条码无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.backStore({code:this.code}).then((res)=>{
        if(res){
          that.$func.endLoading();
          that.$func.showToast('已回店');
          wx.ready(function () {
              let media = document.getElementById("musicBox");
              media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3"
              media.play();
          });
        //   that.selectType(0);
            if(that.type > 0){
                setTimeout(() => {
                    that.scanQRCode(that.type);
                }, 300);
            }
        } 
      })  
    },
    loadmore(){
        console.log(111,this.lastId,this.hasNext);
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        console.log(this.lastId);
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/backStore.vue